import styled, { css } from 'styled-components'
import type { TableCellProps } from './types'

export const Container = styled.div<TableCellProps>`
  display: flex;
  align-items: ${({ $alignItems }) => $alignItems || 'center'};
  justify-content: ${({ $justifyContent }) => $justifyContent};
  flex: ${({ width }) => width};
  padding: var(--space-100) var(--space-200);
  min-width: ${({ $minWidth }) => ($minWidth ? `${$minWidth}px` : '0')};

  ${({ height }) =>
    height
      ? css`
          height: ${height}px;
        `
      : css`
          min-height: 64px;
        `};

  ${({ $minHeight }) =>
    $minHeight &&
    css`
      min-height: ${$minHeight}px;
    `};

  ${({ $alignment }) =>
    $alignment === 'right' &&
    css`
      justify-content: flex-end;
    `};

  ${({ $compact }) =>
    $compact &&
    css`
      min-height: 0;
    `};
`
